import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { Button, Modal } from 'carbon-components-react'

export default function ConfirmMFAFactorResetModal( props ) {

    const [ submitEnabled, setSubmitEnabled ] = useState( false )

    const headerReference = useRef( null )

    const submit = () => {
        props.onSubmit( props.factorId )
    }  
    
    const headerText = 'Are you sure?'
    const submitButtonText = 'Yes Turn Off'
    const cancelButtonText = 'Cancel'

    const text = 'By turning off two-step verification, you will no longer be asked to enter a code when you log into your Eversource account. Do you want to continue?'

    useEffect( () => {
        if( props.open ){
            headerReference?.current?.click() 
            headerReference?.current?.focus() 
        }
    }, [ props.open ] 
    )

    const renderComponent = ()=>{
        return <Modal
            tabIndex={ 0 }
            open = { props.open }
            passiveModal = { true }
            modalAriaLabel= { headerText }
            modalLabel= { headerText }
            modalHeading={ '' }
            onRequestClose={ ( e ) => {
                if( e[ '_reactName' ] === 'onClick' ) {
                    props.handleModalOpenClose( false, props.factorId )
                    setSubmitEnabled( false )
                }
            } } 
            >
            <div className='dashedLine'></div>
            <div className="c-form-group c-modal-space-width mb-3">
                <h3 ref={ headerReference } tabIndex="0" className='bx--modal-header__heading' aria-label={ text }>{ text }</h3>
            </div>
            <div className="modal-footer-center">
                <div className="c-form-group mb-3">
                    <Button   
                        id='turn-off-submit'
                        className="c-btn c-btn--primary mb-8 bx--btn bx--btn--primary"
                        onClick={ () => submit() }
                       
                        tabIndex={ 0 }
                        aria-label={ `${ submitButtonText } Enabled` }
                        data-testid="btn-modal-Submit-mfa"
                    >
                        { submitButtonText }
                    </Button>
                </div>
                <div className="u-text-center mb-3">  
                    <a href='#' onClick={ 
                        ( e ) => { 
                            if( e ) e.preventDefault()
                            props.handleModalOpenClose( false, props.factorId )
                            setSubmitEnabled( false )
                        }
                    }
                        className="btn-modal-center c-link c-cursor-pointer" 
                        tabIndex={ 0 }   
                        aria-label={ cancelButtonText }                      
                        data-testid="btn-modal-cancel">
                        { cancelButtonText }
                    </a>
                </div>  
            </div>  
        </Modal>
    }

    return(
        <>{renderComponent()}</>
    )
}

ConfirmMFAFactorResetModal.propTypes = {
    open: PropTypes.bool,
    factorId: PropTypes.string,
    onSubmit: PropTypes.func,
    handleModalOpenClose: PropTypes.func
}